import {DocumentNode, gql} from "@apollo/client";

export const CURRENCIES_QUERY: DocumentNode = gql(`    
    query GetCurrencies {
        getCurrencies {
            ...CurrencyInfo
        }
    }
`);
